import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

class ObjTitle extends React.Component {
	render() {	
		return (
      <RichText className="t_desc" field={this.props.fields["Push Title"]} tag="p"/>
    )
  }
}

export default ObjTitle;
